import { useTranslation } from 'react-i18next'
import { groupByCountryByCount, groupedAttendance } from '../../data/countries'
import { rallyCityKeys, type Rally } from '../../data/rallies'

import City from './City'

export function Countries({ rally }: { rally?: Rally }) {
  const { t } = useTranslation()
  const grouped = rally
    ? groupByCountryByCount(rallyCityKeys(rally), rally.cities)
    : groupedAttendance
  return (
    <div className='w-full px-6 py-10 columns-1 lg:columns-2 gap-30 bg-gray-100 text-blue-600'>
      {Object.entries(grouped).map(([country, cityKeys]) => (
        <div key={country} className='break-inside-avoid mb-8'>
          <h3 className='text-4xl md:text-5xl text-center font-medium mb-6 underline'>
            {t(`countries.${country}`)}
          </h3>

          <ul>
            {cityKeys.map((cityKey) => (
              <City key={cityKey} city={cityKey} rally={rally} />
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}
